import { loader } from "../utils/loader/index";
import { RouterMeta } from "../route/index";
import { initAppData } from "../common/commonHelper";
import messageListener from "../messageListener";

export default {
    name:"App",
    mixins:[messageListener],
    created:async function(){
        await this.getInitApp();
    },
    computed:{
        logoutEvent:function(){
            return this.$store.state.logOutEventCounter;
        },
    },
    watch:{
        logoutEvent:function(){
            let human = this.$store.state.humanLogOut;
            if(!human){
                let routerName = this.$router.currentRoute.value.matched.length == 0 ? RouterMeta.index: this.$router.currentRoute.value.matched[0].name;
                if(routerName != "login"){
                    this.$store.commit("SetCurrentRoute",{
                        "routeInfo":{ 
                            human:false,
                            name:routerName,
                            params:this.$router.currentRoute.value.params
                        },
                        "routePath":this.$router.currentRoute.value.fullPath
                    });
                }
            }
            this.$router.push(RouterMeta.login.path);
        }
    },
    methods:{
        getInitApp:async function(){
            await initAppData();
            (this.$store.state.siteInfo.CssList || []).forEach(element => {
                loader.loadCss(element);
            });
            (this.$store.state.siteInfo.JsList || []).forEach(element => {
                loader.loadScript(element);
            });
        }
    }
}